import {
    filterAgrupations,
    filterBrands,
    filterModels,
    filterKm,
    filterTransmission,
    filterEnergies,
    filterZones,
    filterPowerMax,
    filterPriceMax,
    filterFavorite,
    filterBidden,
    filterPlate,
    filterRegistrationDate,
    filterStates,
    filterBuyer,
    filterDatePurchaseFrom,
    filterDatePurchaseTo,
    filterYearPurchase,
    filterMonthPurchase,
    filterComercialProducts,
    filterDealers,
    filterVIN,
    filterDatePurchaseOptionFrom,
    filterDatePurchaseOptionTo,
    filterWarrantyExtension,
    filterFinancialOperation,
} from '../constants/Filters';

export function checkInitFilterValues(
    selectedFilterCode,
    pSelectedFilters,
    pFilters
) {
    if (pFilters === undefined) return null;

    let resetValueFilters = [];
    switch (selectedFilterCode) {
        case filterKm:
            resetValueFilters = pFilters.KmsMax;
            break;
        case filterPowerMax:
            resetValueFilters = pFilters.PowerMax;
            break;
        case filterPriceMax:
            resetValueFilters = pFilters.PriceMax;
            break;
        case filterRegistrationDate:
            resetValueFilters = pFilters.RegistrationDate;
            break;
        case filterYearPurchase:
            resetValueFilters = pFilters.BuyYearMax;
            break;
        default:
    }
    if (
        JSON.stringify(pSelectedFilters[selectedFilterCode]) !=
        JSON.stringify(resetValueFilters)
    )
        return resetValueFilters;
    else return null;
}

export function checkCountFilters(selectFilters_aux, filters) {
    let countFilters = 0;
    Object.keys(selectFilters_aux).map((nameFilter, index) => {
        if (selectFilters_aux[nameFilter])
            switch (nameFilter) {
                case filterAgrupations:
                case filterBrands:
                case filterModels:
                case filterTransmission:
                case filterTransmission:
                case filterZones:
                case filterStates:
                case filterBuyer:
                case filterEnergies:
                case filterMonthPurchase:
                case filterComercialProducts:
                case filterDealers:
                    if (selectFilters_aux[nameFilter].length > 0)
                        countFilters++;
                    break;
                case filterKm:
                case filterPowerMax:
                case filterPriceMax:
                case filterRegistrationDate:
                case filterYearPurchase:
                    if (
                        selectFilters_aux[nameFilter].length > 0 &&
                        checkInitFilterValues(
                            nameFilter,
                            selectFilters_aux,
                            filters
                        ) != null
                    )
                        countFilters++;
                    break;
                case filterFavorite:
                case filterBidden:
                case filterWarrantyExtension:
                    if (selectFilters_aux[nameFilter] == true) countFilters++;
                    break;
                case filterPlate:
                case filterVIN:
                case filterDatePurchaseFrom:
                case filterDatePurchaseTo:
                case filterDatePurchaseOptionTo:
                case filterDatePurchaseOptionFrom:
                case filterFinancialOperation:
                    if (
                        selectFilters_aux[nameFilter] != '' &&
                        selectFilters_aux[nameFilter] != null
                    )
                        countFilters++;
                    break;
                default:
                    break;
            }
    });
    return countFilters;
}

export function checkFilterAvailable(availableFilters, filterName) {
    let available = true;
    if (availableFilters.length > 0) {
        available = availableFilters.includes(filterName);
        // if (
        //     filterName !== '' &&
        //     (!filters[filterName] ||
        //         (filters[filterName] && filters[filterName].length === 0))
        // )
        //     available = false;
    } else {
        available = false;
    }

    return available;
}
